import { motion } from "framer-motion";
import { useProject } from "../../providers/projectProvider";

export const TickProject = () => {
  const { projects, setCurrentProject, currentProjectId } = useProject();

  const handleCurrentProject = (index) => {
    setCurrentProject(index);
  };

  const sortedProjects = [...projects].sort((a, b) => a.id - b.id);
  return (
    <motion.div className="row check-project-list font-neue">
      <ul className="d-flex text-white flex-row">
        {sortedProjects.map((project, index) => (
          <li key={project.id}>
            <label htmlFor={project.id}> {project.name} </label>
            <label className="checkbox bounce mx-1 p-0">
              <input
                type="checkbox"
                checked={project.id === currentProjectId}
                onChange={() => handleCurrentProject(project.id)}
                id={project.id}
              />
              <svg viewBox="0 0 21 21">
                <polyline points="5 10.75 8.5 14.25 16 6"></polyline>
              </svg>
            </label>
          </li>
        ))}
      </ul>{" "}
    </motion.div>
  );
};
